const codigosPostales = [
  { cp: '', provincia: '', canship: true },
]

export default codigosPostales
